import { useUserStore } from "@/store/userStore";

/**
 * Hook to determine if the current user account is an OEM account
 * @returns {boolean} True if the user's role is "oem" (case-insensitive), false otherwise
 */
export const useIsOemAccount = (): boolean => {
  const userData = useUserStore((state) => state.user);
  return userData?.role?.toLowerCase() === "oem";
};
